<template>
<v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app v-if="isAuthenticated" style="z-index: 13;">
        <v-list nav dense>
            <v-list-group v-for='(navLink, index) in menuList' :key="index">
                <v-list-item slot='activator' @click="userSignOut" v-if="index == menuList.length - 1">
                    <v-list-item-icon>
                        <v-icon>{{ navLink.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ navLink.title }}</v-list-item-title>
                </v-list-item>
                <v-list-item slot='activator' :to="navLink.to" v-else>
                    <v-list-item-icon>
                        <v-icon>{{ navLink.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{ navLink.title }}</v-list-item-title>
                </v-list-item>
                <v-list-item v-for='sub in navLink.subMenu' :key="sub.title" style="margin-left: 10px" :to="sub.to">
                    <v-list-item-icon>
                        <!-- <v-icon>{{ sub.icon }}</v-icon> -->
                    </v-list-item-icon>
                    <v-list-item-title>{{ sub.title }}</v-list-item-title>
                </v-list-item>
            </v-list-group>
        </v-list>
    </v-navigation-drawer>
    <v-app-bar app color="indigo" dark style="z-index: 12;">
        <v-app-bar-nav-icon @click="drawer = !drawer" v-if="isAuthenticated"></v-app-bar-nav-icon>
        <v-toolbar-title> {{ appTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>

        <template v-if="isAuthenticated">{{loggedInUsername}}</template>
        <v-btn icon @click="userSignOut" v-if="isAuthenticated">
            <v-icon>mdi-exit-to-app</v-icon>
        </v-btn>

        <v-btn tile depressed color="transparent" to="/dashboard" v-if="!isAuthenticated">
            <v-icon class="mr-1">mdi-login</v-icon>
            Login
        </v-btn>
    </v-app-bar>

    <v-main>
        <router-view></router-view>
    </v-main>
</v-app>
</template>

<script>
import firebase from "firebase/compat/app";
import "firebase/compat/analytics";
import {
    mapGetters
} from "vuex";
export default {
    name: 'App',
    metaInfo: {
        titleTemplate: 'Thaisook | %s',
        changed(metaInfo) {
            firebase.analytics().setCurrentScreen(metaInfo.title);
            firebase.analytics().logEvent("page_view");
            firebase.analytics().logEvent("screen_view", {
                app_name: "web",
                screen_name: metaInfo.title,
                // app_version: 1
            });
        }
    },
    mounted() {
        firebase.auth().onAuthStateChanged(user => {
            if (user) {
                // this.$analytics.setUserId(user.uid);
                // this.$analytics.setUserProperties({
                //     account_type: "Basic" // can help you to define audiences
                // });
            }
        });
    },
    data: () => ({
        drawer: false,
        group: null,
        challengeAdminItems: [{
                icon: "mdi-file-table-box-multiple-outline",
                title: "Challenge",
                to: "/challenge",
            },
            {
                icon: "mdi-cloud-question",
                title: "Quiz",
                to: "/quiz",
                permissions: 'accessQuiz'
            },
            {
                icon: "mdi-text-box-check",
                title: "Online Survey",
                to: "/online-survey",
                permissions: 'accessOnlineSurvey'
            },
            {
                icon: "mdi-calendar-multiselect",
                title: "Coach Program",
                //to: "/program",
                permissions: 'accessCoachAdmin',
                subMenu: [{
                        icon: "mdi-calendar-multiselect",
                        title: "รายคน",
                        to: "/program/member-list",
                        permissions: 'accessCoachAdmin',
                    },
                    {
                        icon: "mdi-calendar-multiselect",
                        title: "รายโปรแกรม",
                        to: "/program/program-list",
                        permissions: 'accessCoachAdmin',
                    }
                ]
            },
            {
                icon: "mdi-account",
                title: "Coach",
                to: "/org-coach/",
                permissions: 'accessOrgAdmin'
            },
            {
                icon: "mdi-office-building",
                title: "Organization",
                to: "/org",
                permissions: 'accessOrgAdmin'
            },
            {
                icon: "mdi-gift",
                title: "Rewards",
                to: "/wellness-rewards",
                permissions: 'accessRewardProduct'
            }
        ],
        superAdminItems: [{
                icon: "mdi-file-table-box-multiple-outline",
                title: "Challenge",
                to: "/challenge",
            },
            {
                icon: "mdi-account",
                title: "User Management",
                to: "/user",
            },
            {
                icon: "mdi-cloud-question",
                title: "Quiz",
                to: "/quiz"
            },
            {
                icon: "mdi-text-box-check",
                title: "Online Survey",
                to: "/online-survey"
            },
            {
                icon: "mdi-calendar-multiselect",
                title: "Coach Program",
                //to: "/program",
                permissions: 'accessCoachAdmin',
                subMenu: [{
                        icon: "mdi-calendar-multiselect",
                        title: "รายคน",
                        to: "/program/member-list",
                        permissions: 'accessCoachAdmin',
                    },
                    {
                        icon: "mdi-calendar-multiselect",
                        title: "รายโปรแกรม",
                        to: "/program/program-list",
                        permissions: 'accessCoachAdmin',
                    }
                ]
            },
            {
                icon: "mdi-office-building",
                title: "Organization",
                to: "/org"
            },
            {
                icon: "mdi-gift",
                title: "Rewards",
                to: "/wellness-rewards",
                permissions: 'accessRewardProduct'
            }
        ],
    }),
    created() {
        setTimeout(() => {
            if( this.$route.name != 'program View' 
                && this.$route.name != 'program View Member Edit' 
                && this.$route.name != 'program View Member Result' 
                && this.$route.name != 'program View Member Report by mod' 
                && this.$route.name != 'programFormEdit'
                ){
                this.drawer = true;
            }
        }, "1000");
    },
    computed: {
        ...mapGetters([
            "appTitle",
            "loggedInUserId",
            "loggedInUsername",
            "isAuthenticated",
            "isSuperAdmin",
            "isChallengeAdmin",
            "isAccessQuiz",
            "isAccessOnlineSurvey",
            "isAccessCoachAdmin",
            "isAccessOrgAdmin",
            "isAccessPILMAdmin",
            "isAccessRewardProduct"
        ]),
        menuList() {
            let menuList = [];
            if (this.isSuperAdmin) {
                this.superAdminItems.forEach((item) => {
                    menuList.push(item);
                });
            } else if (this.isChallengeAdmin) {
                if( this.isAccessPILMAdmin ){
                    this.challengeAdminItems.forEach((item) => {
                        if (item.title != 'Coach' && (item.permissions == undefined || item.permissions == 'accessCoachAdmin' || item.permissions == 'accessOrgAdmin') ) {
                            menuList.push(item);
                        }
                    });
                }
                else{
                    this.challengeAdminItems.forEach((item) => {
                        if (item.permissions == undefined 
                            || (item.permissions == 'accessQuiz' && this.isAccessQuiz) 
                            || (item.permissions == 'accessOnlineSurvey' && this.isAccessOnlineSurvey) 
                            || (item.permissions == 'accessCoachAdmin' && this.isAccessCoachAdmin) 
                            || (item.permissions == 'accessOrgAdmin' && this.isAccessOrgAdmin)
                            || (item.permissions == 'accessRewardProduct' && this.isAccessRewardProduct)
                        ) {
                            menuList.push(item);
                        }
                    });
                }
            }
            menuList.push({
                icon: "mdi-account-group",
                title: "Group",
                to: "/dashboard"
            });
            menuList.push({
                icon: "mdi-exit-to-app",
                title: "Logout",
                to: ""
            });
            return menuList;
        }
    },
    methods: {
        userSignOut() {
            this.$store.dispatch("userSignOut");
        },
    }
};
</script>

<style>
tbody tr {
    cursor: pointer;
}

tbody tr td.non-clickable {
    cursor: auto;
}

tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
}

.v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon{
    display: none;
}
</style>
